import useOnCropAnnotationChangedOrSelected from "./useOnCropAnnotationChangedOrSelected";

export default useOnCropAnnotationChangedOrSelected;